import { getUserSSO } from '@lib/api'
import { userSSOKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

// Only developers may read this, so callers that can't be sure the signed-in
// user is one should pass `enabled: false` rather than provoke a 403.
export const useUserSSO = (userId: number, enabled = true) => {
  return useQuery(userSSOKeys.byUser(userId), () => getUserSSO(userId), {
    enabled,
  })
}
